module.exports = __webpack_public_path__ + "static/media/tip-lightbulb.52247076.svg";